import React from "react";

function Boresha1() {
  return (
    <div>
      <div className="my-4">
        <ul className="list-disc list-inside">
        <li>Provides financial security during the most crucial years of your child's life.</li>
        <li>Offers a perfect blend of investment and savings in a single plan.</li>
        <li>Safeguards the child's future, even in the event of the untimely demise of the parent.</li>
        <li>Guaranteed lump sum amounts equal to the principal sum payable in the last three years of the plan.</li>
        <li>Guarantee payment of the maturity benefit, in the event of death or total permanent disability of the life assured before the maturity date.</li>
        </ul>
      </div>
    </div>
  );
}

export default Boresha1;
